import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7e816b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "coaching-session"
}

import { ref, onMounted, watch, computed } from 'vue'
import CoachingSessionView from '@/components/CoachingSessionView'
import CoachingSessionLoadingView from '@/components/CoachingSessionLoadingView'
import CoachingSessionAboutCoach from '@/components/CoachingSessionAboutCoach'
import { useCoachingSessionStore } from '@/components/CoachingSessionStore'
import { useToast } from '@/components/BsToastQueueStore'
import { useEventBus } from '@vueuse/core'
import { cancelSessionKey } from '@/config/events'
import CoachingSessionScheduleDetail from '@/components/CoachingSessionScheduleDetail'
import CoachingSessionCancel from '@/components/CoachingSessionCancel'
import CoachingSessionCancelConfirmation from '@/components/CoachingSessionCancelConfirmation'
import { useSessionRegistryStore } from '../SessionRegistryStore'
import { Event as ClassroomEvent, WithId } from '@/types/api'
import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachingSession',
  props: {
    isEbar: { type: Boolean },
    sessions: {}
  },
  setup(__props: any) {

const props = __props

const { coachingState, coachingActions } = useCoachingSessionStore()
const { sessionActions } = useSessionRegistryStore()
const { showErrorToast } = useToast()
const showSessionCancel = ref(false)
const showCoachDetails = ref(false)
const showScheduleDetails = ref(false)
const showCancelConfirmation = ref(false)

const cancelSessionEventBus = useEventBus(cancelSessionKey)

onMounted(async () => {
  if (!coachingState.session.model) {
    await coachingActions.loadCoachingSession(props.sessions)
  }
})

watch(
  () => coachingState.session.error,
  (message) => message && showErrorToast({ message })
)

watch(
  () => coachingState.about.error,
  (message) => message && showErrorToast({ message })
)

watch(
  () => coachingState.cancel.error,
  (message) => message && showErrorToast({ message })
)

cancelSessionEventBus.on((event: (ClassroomEvent & WithId) | undefined = undefined) => {
  if (event && coachingState.cancel.model) {
    coachingState.cancel.model.event = event
  }
  openCancelSessionModal()
})

async function openCancelSessionModal() {
  showSessionCancel.value = true
}

async function handleScheduleDetail() {
  showScheduleDetails.value = true
}

async function handleAboutCoach() {
  showCoachDetails.value = true
  coachingActions.loadAboutCoach()
}

async function handleCancelSession() {
  await coachingActions.removeFromSession()
  if(coachingState.cancel.error) {
    return
  }

  showSessionCancel.value = false
  showCancelConfirmation.value = true
}

async function handleConfirmationClosed() {
  showCancelConfirmation.value = false
  await sessionActions.loadSessions()
}

const showScheduleNotification = computed(()=> coachingState.scheduleDetail.model !== null)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isEbar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(coachingState).session.model && !_unref(coachingState).session.isLoading)
            ? (_openBlock(), _createBlock(_unref(CoachingSessionView), {
                key: 0,
                "model-value": _unref(coachingState).session.model,
                "show-schedule-notification": showScheduleNotification.value,
                onShowCancelSession: openCancelSessionModal,
                onShowAboutCoach: handleAboutCoach,
                onShowScheduleDetail: handleScheduleDetail
              }, null, 8, ["model-value", "show-schedule-notification"]))
            : (_unref(coachingState).session.isLoading)
              ? (_openBlock(), _createBlock(_unref(CoachingSessionLoadingView), { key: 1 }))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(CoachingSessionCancel), {
      visible: showSessionCancel.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showSessionCancel).value = $event)),
      "model-value": _unref(coachingState).cancel.model,
      onRemoveFromSession: handleCancelSession
    }, null, 8, ["visible", "model-value"]),
    _createVNode(_unref(CoachingSessionCancelConfirmation), {
      visible: showCancelConfirmation.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showCancelConfirmation).value = $event)),
      onClosed: handleConfirmationClosed
    }, null, 8, ["visible"]),
    _createVNode(_unref(CoachingSessionAboutCoach), {
      visible: showCoachDetails.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((showCoachDetails).value = $event)),
      "model-value": _unref(coachingState).about.model,
      "is-loading": _unref(coachingState).about.isLoading
    }, null, 8, ["visible", "model-value", "is-loading"]),
    _createVNode(_unref(CoachingSessionScheduleDetail), {
      visible: showScheduleDetails.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showScheduleDetails).value = $event)),
      modelValue: _unref(coachingState).scheduleDetail.model,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(coachingState).scheduleDetail.model) = $event))
    }, null, 8, ["visible", "modelValue"])
  ], 64))
}
}

})